export function generateAutocompleteValue() {
  const crypto = (window && window.crypto) || window.Crypto;
  const array = new Uint32Array(1);
  const random = crypto.getRandomValues(array);
  return random[0];
}
